import {Botao, PaginaLogada} from "../../componentes";
import {Card} from "react-bootstrap";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {CirastServico} from "../../servicos";
import {formatarData} from "../../util";
import {formatarDataHora} from "../../util/mascara";

export default function DetalheAtendimentoCirast() {

  const parametros = useParams()
  const [atendimentos, setAtendimentos] = useState([])
  const [consulta, setConsulta] = useState({})
  const [isCarregando, setIsCarregando] = useState(false)

  function carregarConsulta() {
    setIsCarregando(true)
    const id = parametros.id
    CirastServico.getConsultaPorId(id)
      .then(res => res.json())
      .then(dados => {
        setConsulta(dados.consulta)
        setAtendimentos(dados.atendimentos)
      })
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    carregarConsulta()
  }, []);

  return (
    <PaginaLogada titulo="Detalha Atendimento" isCarregando={isCarregando}>

      <Card className="col-lg-12">
        <div className="row mt-2">
          <div className="col-lg-2">
            <Botao icone='bi bi-arrow-left' onClick={() => window.history.back()}>Voltar</Botao>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 mt-5">
            <h4>Atendimentos para <b>{consulta.paciente} </b></h4>
          </div>
        </div>
        <div className="row mt-4">
          <table className="col-lg-12 text-center table-bordered table table-striped table-hover table-header">
            <thead>
            <tr>
              <th>Clinica</th>
              <th>Data Hora</th>
              <th>Atendente</th>
            </tr>
            </thead>
            <tbody>
            {atendimentos.map((v, k) => {
              return (
                <tr key={k}>
                  <td>{consulta.clinicaCirast.nome}</td>
                  <td>{formatarDataHora(v.dataHoraAtendimento) }</td>
                  <td>{v.atendente}</td>
                </tr>
              )
            })}
            </tbody>
          </table>
        </div>
      </Card>
    </PaginaLogada>
  )
}